import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { AdminPage } from "@/components/admin/AdminSidebar";
import { Button } from "@/components/ui/button";
import { useUserRoles } from "@/hooks/use-user-roles";
import { EstimadorWizard } from "@/components/estimador/EstimadorWizard";

export const Route = createFileRoute("/admin/estimador")({
  head: () => ({
    meta: [
      { title: "Valorador de valor — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: EstimadorPage,
});

function EstimadorPage() {
  const { roles } = useUserRoles();
  const isAdmin = (roles ?? []).includes("admin");

  if (!isAdmin) {
    return (
      <AdminPage title="Valorador de valor">
        <p className="text-sm text-muted-foreground">
          Esta herramienta solo está disponible para administradores.
        </p>
      </AdminPage>
    );
  }

  return (
    <AdminPage
      title="Valorador de valor"
      description="Estima el valor de un negocio que no está publicado. No se crea ningún anuncio."
      actions={
        <Button asChild variant="ghost" size="sm">
          <Link to="/admin/herramientas">
            <ArrowLeft className="mr-1 h-4 w-4" />
            Herramientas
          </Link>
        </Button>
      }
    >
      <EstimadorWizard />
    </AdminPage>
  );
}
